import React from 'react'
import PaymentSteps from './PaymentSteps'

const MakePaymentSection = () => {
    return (
        <section className="xl:pb-[135px] md:pb-[95px] pb-[56px]">
            <div className="container">
                <h2 className="text-heading-1 font-bold text-primary-text text-center">
                    How to Make Payment
                </h2>
                <PaymentSteps />
            </div>
        </section>
    )
}

export default MakePaymentSection